<template>
  <div>
    <DataTable
      ref="DataTable"
      :data-model="'samples'"
      :items="items"
      :loading="loading"
      :display-name-plural="$t('routes.SamplesInAnalysis')"
      :permission-name="'Samples'"
      :allow-delete="false"
      :allow-create="false"
      :items-per-page="itemsPerPage"
      :exclude-fields="['id', 'customerId', 'hasBarcode']">
      <template #cell(status)="row">
        {{ $t('samples.Status.'+row.item.status) }}
      </template>
    </DataTable>
    <b-modal id="modal-center"
             ref="scanModal"
             centered
             :static="true">
      <template #modal-header>
        <div class="d-flex justify-content-center w-100 text-center">
          <h3>
            {{ $t('common.ScanBarcode') }}
          </h3>
        </div>
      </template>
      <template #modal-footer="{ cancel, ok }">
        <b-button
          variant="danger"
          @click="$refs.scanModal.hide(); $barcodeScanner.destroy()">
          {{ $t('common.Cancel') }}
        </b-button>
      </template>
    </b-modal>
  </div>
</template>
<script>
import DataTable from '@components/admin/DataTable';

export default {
  components: {
    DataTable
  },
  data() {
    return {
      items: [],
      loading: true
    };
  },
  props: {
    itemsPerPage: {
      type: Number,
      required: false,
      default: 10
    }
  },
  created() {
    this.reload();
  },
  methods: {
    reload() {
      this.loading = true;
      this.axios.get('/admin/samples/inanalysis')
        .then((res) => {
          if (res.status === 200 && res.data.result.length > 0) {
            this.items = res.data.result;
          } else {
            this.items = [];
          }
          this.loading = false;
        }).catch((err) => Promise.reject(err))
        .finally(() => {
          this.$refs.DataTable.finishSpinner();
        });
    },
    scanBarcode(code) {
      this.axios.post('/admin/samples/receivetoanalysis', {
        Barcode: code
      })
        .then((res) => {
          this.reload();
          this.$root.$bvToast.toast(this.$t('ReceiveSample.SuccessToast.Body'), {
            title: this.$t('ReceiveSample.SuccessToast.Title'),
            variant: 'success',
            toaster: 'b-toaster-top-right'
          });
          Promise.resolve(res);
        })
        .catch((err) => {
          this.$root.$bvToast.toast(this.$t('ReceiveSample.FailToast.Body'), {
            title: this.$t('ReceiveSample.FailToast.Title'),
            variant: 'danger',
            toaster: 'b-toaster-top-right'
          });
          Promise.reject(err);
        });
    }
  }
};
</script>
<style scoped></style>
